import { render, staticRenderFns } from "./QuestionOptions.vue?vue&type=template&id=252139e0"
import script from "./QuestionOptions.vue?vue&type=script&lang=js"
export * from "./QuestionOptions.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports